import { Grid } from '@mui/material';

import React, { useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import ButtonComp from 'common/components/Button/ButtonComp';
import SideDrawer from 'common/components/SideDrawer/SideDrawer';
import TabBar from 'common/components/TabBar/TabBar';
import AlertComponent from 'common/components/ToastMessage/ToastMessage';
import { RootState } from 'common/store/AppStore';
import { setToastMessage } from 'common/store/reducer/commonReducer';
import {
	setQueueDrawer,
	setQueueDetails,
} from 'common/store/reducer/workflowReducer';
import { toSentenceCase } from 'common/utils/utilFunctions';

import CreateQueue from './Queue/CreateQueue';
import QueueList from './QueueList';
import WorkflowList from './WorkflowList';

import styles from './Workflow.module.scss';

const Workflow = () => {
	const dispatch = useDispatch();

	const [activeTab, setActiveTab] = useState<number>(0);
	const [showCreateButton, setShowCreateButton] = useState<boolean>(
		activeTab === 0,
	);
	const tabs = [
		{ id: 1, children: <QueueList key="queue" /> },
		{ id: 2, children: <WorkflowList key="workflow" /> },
	];
	const tabDetails: any[] = [
		{
			name: 'Queue',
		},
		{
			name: 'Workflow',
		},
	];

	const openQueueDrawer = useSelector(
		(state: RootState) => state.workflowmodule.queueDrawer,
	);
	const { isToastOpen, message, severity } = useSelector(
		(state: RootState) => state.common.toastMessage,
	);

	const openQueueDetailsPage = () => {
		dispatch(
			setQueueDetails({
				type: 'create',
				data: {
					queueId: '',
					queueName: '',
					users: [],
					workFlowStepIds: [],
				},
			}),
		);

		dispatch(setQueueDrawer(true));
	};
	const onTabChange = (index: number) => {
		setActiveTab(index);
		setShowCreateButton(index === 0);
	};
	const handleClose = () => {
		dispatch(
			setToastMessage({ isToastOpen: false, severity: '', message: '' }),
		);
	};

	useEffect(() => {
		setActiveTab(0);
	}, [openQueueDrawer]);

	return (
		<Grid container data-testid="table-area">
			<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
				<TabBar
					activeTab={activeTab}
					onTabChange={onTabChange}
					details={tabDetails}
					components={tabs}
					showCount={false}
					showButton={showCreateButton}
					childComponent={
						showCreateButton && (
							<ButtonComp
								btnType="secondary"
								size="small"
								data-testid="create-new-btn"
								compClass={styles['create-btn']}
								onClick={openQueueDetailsPage}
							>
								{toSentenceCase('Create New')}
							</ButtonComp>
						)
					}
				/>
			</Grid>
			<AlertComponent
				open={isToastOpen ?? false}
				toastMessage={message ?? ''}
				severity={severity ?? ''}
				handleCloseMessage={handleClose}
				vertical="top"
				horizontal="right"
				autoHideDuration={5000}
			/>
			{openQueueDrawer && (
				<SideDrawer
					className={styles['create-queue-drawer']}
					drawerState={openQueueDrawer}
				>
					<CreateQueue />
				</SideDrawer>
			)}
		</Grid>
	);
};

export default Workflow;
